<app-tabla-general [displayedColumns]="displayedColumns" [moduloActual]="'visitantes'"></app-tabla-general>
<router-outlet></router-outlet>